export const PARTNER_API_SERVICE_BASE_URL =
  process.env.REACT_APP_PARTNER_API_SERVICE_BASE_URL ||
  "http://localhost:4005/";

// user token
export const AUTH_TOKEN = "dhptoken";
